<template>
  <div>
    <form class="form-container" action="" @submit.prevent="submitHandler">
      <!-- Title -->
      <label for="title">Title <span class="red">*</span></label>
      <input
        v-model="compensation.title"
        id="title"
        required
        type="text"
        placeholder="Compensation title"
      />

      <!-- Total Compensated CO2 kg -->
      <label for="total_compensated_co2_kg"
        >Total Compensated CO2 kg <span class="red">*</span></label
      >
      <input
        v-model="compensation.total_compensated_co2_kg"
        id="total_compensated_co2_kg"
        type="number"
        placeholder="23"
        required
      />

      <!-- Description -->
      <label for="description">Description</label>
      <textarea
        v-model="compensation.description"
        class="description"
        id="description"
        type="text"
        maxlength="500"
        placeholder="June compensation"
      />

      <!-- Compensated At -->
      <label for="compensated_at"
        >Compensated at
        <small
          ><i
            >(if not specified, actual date will be taken as default)</i
          ></small
        ></label
      >
      <input
        v-model="compensation.compensated_at"
        id="compensated_at"
        type="datetime-local"
      />

      <!-- Proof URL -->
      <label for="proof_url">Proof URL <span class="red">*</span></label>
      <input
        v-model="compensation.proof_url"
        required
        id="proof_url"
        type="url"
        placeholder="https://www.example.com/invoice.pdf"
      />

      <!-- Submit Button -->
      <button class="submit-btn" type="submit">Send</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "CompensationForm",
  data: function () {
    return {
      compensation: {
        title: "",
        compensated_at: null,
        proof_url: "",
        details_url: "",
        description: "",
        total_compensated_co2_kg: null,
      },
    };
  },
  props: {
    //to tell parent component to show the CompensatedData component
    showCompensatedData: {
      type: Function,
    },
  },
  methods: {
    submitHandler() {
      // to avoid an " ", datepicker when clears the date, it sets it to that value
      if (!this.compensation.compensated_at) {
        this.compensation.compensated_at = new Date()
          .toISOString()
          .slice(0, 10);
      }
      console.log(this.compensation.compensated_at)
      axios
        .post(
          process.env.API_URL +
            "/internal/upload-compensation?key=" +
            process.env.API_KEY,
          this.compensation
        )
        .then(() => {
          alert("Compensation logged successfully");
          this.showCompensatedData(this.compensation);
          this.clearForm();
        })
        .catch((err) => {
          alert("Sorry, something went wrong. Please try again.");
          console.log(err);
        });
      //TODO(JP): Ask BF why console.log(this.compensation) shows the properties but empty
      /*  this.showCompensatedData(this.compensation);
      this.clearForm(); */
    },
    clearForm() {
      this.compensation.title = "";
      this.compensation.compensated_at = null;
      this.compensation.proof_url = "";
      this.compensation.details_url = "";
      this.compensation.description = "";
      this.compensation.total_compensated_co2_kg = null;
    },
  },
};
</script>

<style lang="css">
.form-container {
  height: 80vh;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  max-width: 80vw;
  margin: 0 auto;
}
.description {
  height: 15vh;
}
.red {
  color: #ff0000;
}
.submit-btn {
  background-color: #91be4d;
  color: #ffff;
  font-weight: bold;
  border: none;
  height: 4vh;
  border-radius: 5px;
  text-transform: uppercase;
  font-family: "Nunito", sans-serif;
}
@media (min-width: 768px) {
  .form-container {
    width: 40rem;
  }
}
</style>
